import { VendorEnum } from "@/enums/vendorEnum";
import TableSettingsVendor from "../interfaces/TableSettingsVendor";

class VendorPdfSettingsHelper {
    public static readonly tablePDFSettings: Record<string, TableSettingsVendor[]> = {
        [VendorEnum.ANDERSEN]: [
            { label: "Invoice Date", key: "invoiceDate", width: "10%" },
            { label: "Order Number", key: "orderNumber", width: "12%" },
            { label: "Lansing Account #", key: "harveyAccount", width: "12%" },
            { label: "Account Name", key: "harveyAccountName", width: "21%" },
            { label: "Product Purchased", key: "productPurchased", width: "25%" },
            {
                label: "Andersen Product Code",
                key: "andersenProductCode",
                width: "20%",
            },
        ],
        [VendorEnum.BOSTIK]: [
            { label: "Invoice Date", key: "invoiceDate", width: "10%" },
            { label: "Order Number", key: "orderNumber", width: "10%" },
            { label: "Lansing Account #", key: "harveyAccount", width: "10%" },
            { label: "Account Name", key: "harveyAccountName", width: "18%" },
            { label: "Product Purchased", key: "productPurchased", width: "20%" },
            { label: "Bostik Product Code", key: "bostikProductCode", width: "13%" },
            { label: "UOM", key: "deal", width: "6%" },
            { label: "Qty", key: "dealQty", width: "6%" },
            { label: "Amount", key: "amount", width: "8%" },
        ],
        [VendorEnum.CERTAINTEED]: [
            { label: "Invoice Date", key: "invoiceDate", width: "10%" },
            { label: "Order Number", key: "orderNumber", width: "15%" },
            { label: "Lansing Account #", key: "harveyAccount", width: "15%" },
            { label: "Account Name", key: "harveyAccountName", width: "25%" },
            { label: "Product Purchased", key: "productPurchased", width: "35%" },
        ],
        [VendorEnum.CBB]: [
            { label: "Invoice Date", key: "invoiceDate", width: "10%" },
            { label: "Order Number", key: "orderNumber", width: "15%" },
            { label: "Lansing Account #", key: "harveyAccount", width: "15%" },
            { label: "Account Name", key: "harveyAccountName", width: "25%" },
            { label: "Product Purchased", key: "productPurchased", width: "35%" },
        ],
        [VendorEnum.GAF]: [
            { label: "Invoice Date", key: "invoiceDate", width: "10%" },
            { label: "Order Number", key: "orderNumber", width: "12%" },
            { label: "Lansing Account #", key: "harveyAccount", width: "12%" },
            { label: "Account Name", key: "harveyAccountName", width: "20%" },
            { label: "Product Purchased", key: "productPurchased", width: "30%" },
            { label: "Deal UOM ", key: "deal", width: "8%" },
            { label: "Deal Qty", key: "dealQty", width: "8%" },
        ],
        [VendorEnum.JAMES_HARDIE]: [
            { label: "Invoice Date", key: "invoiceDate", width: "10%" },
            { label: "Order Number", key: "orderNumber", width: "10%" },
            { label: "Lansing Account #", key: "harveyAccount", width: "15%" },
            { label: "Account Name", key: "harveyAccountName", width: "20%" },
            { label: "Product Purchased", key: "productPurchased", width: "45%" },
        ],
        [VendorEnum.OWENS_CORNING]: [
            { label: "Invoice Date", key: "invoiceDate", width: "8%" },
            { label: "Order Number", key: "orderNumber", width: "10%" },
            { label: "Lansing Account #", key: "harveyAccount", width: "10%" },
            { label: "Account Name", key: "harveyAccountName", width: "10%" },
            { label: "Product Purchased", key: "productPurchased", width: "23%" },
            { label: "Owens Corning Product Code", key: "owensCorningProductCode", width: "19%" },
            { label: "UOM", key: "deal", width: "6%" },
            { label: "Qty", key: "dealQty", width: "6%" },
            { label: "Amount", key: "amount", width: "8%" },
        ],
        [VendorEnum.SIMONTON]: [
            { label: "Invoice Date", key: "invoiceDate", width: "10%" },
            { label: "Order Number", key: "orderNumber", width: "12%" },
            { label: "Lansing Account #", key: "harveyAccount", width: "12%" },
            { label: "Account Name", key: "harveyAccountName", width: "20%" },
            { label: "Product Purchased", key: "productPurchased", width: "29%" },
            {
                label: "Simonton Product Code",
                key: "simontonProductCode",
                width: "17%",
            },
        ],
        [VendorEnum.TAMKO]: [
            { label: "Invoice Date", key: "invoiceDate", width: "10%" },
            { label: "Order Number", key: "orderNumber", width: "10%" },
            { label: "Lansing Account #", key: "harveyAccount", width: "10%" },
            { label: "Account Name", key: "harveyAccountName", width: "25%" },
            { label: "Product Purchased", key: "productPurchased", width: "25%" },
            { label: "Qty", key: "dealQty", width: "6%" },
            { label: "Unit", key: "unit", width: "6%" },
            { label: "Amount", key: "amount", width: "8%" },
        ],
        [VendorEnum.WESTLAKE_ROYAL]: [
            { label: "Invoice Date", key: "invoiceDate", width: "10%" },
            { label: "Order Number", key: "orderNumber", width: "12%" },
            { label: "Lansing Account #", key: "harveyAccount", width: "12%" },
            { label: "Account Name", key: "harveyAccountName", width: "20%" },
            { label: "Product Purchased", key: "productPurchased", width: "19%" },
            {
                label: "Westlake Product Code",
                key: "westlakeProductCode",
                width: "15%",
            },
            { label: "UOM", key: "deal", width: "6%" },
            { label: "Qty", key: "dealQty", width: "8%" },
            { label: "Amount", key: "amount", width: "8%" },
        ],
        [VendorEnum.WOLF]: [
            { label: "Invoice Date", key: "invoiceDate", width: "10%" },
            { label: "Order Number", key: "orderNumber", width: "10%" },
            { label: "Lansing Account #", key: "harveyAccount", width: "10%" },
            { label: "Account Name", key: "harveyAccountName", width: "18%" },
            { label: "Product Purchased", key: "productPurchased", width: "20%" },
            { label: "Wolf Product Code", key: "wolfProductCode", width: "10%" },
            { label: "Deal UOM", key: "deal", width: "8%" },
            { label: "Deal Qty", key: "dealQty", width: "5%" },
            { label: "Sale Amount", key: "amount", width: "9%" },
        ],
    };

    public static readonly tablePDFNameMapper: Record<string, string> = {
        [VendorEnum.CBB]: "PlyGem Pro Solutions",
        [VendorEnum.JAMES_HARDIE]: "The James Hardie™ ALLIANCE"
    };
}

export default VendorPdfSettingsHelper;
